import React from 'react'

import ProjectBiddingWizardStep from './BiddingWizardStep'
import BiddingBrief from "./components/BiddingBrief";
import {useProject} from "../../providers/ClientProjectProvider";
import {Navigate, useLocation, useNavigate, useOutletContext, useParams} from "react-router-dom";
import {Affix} from 'antd';
import InfoTooltip from "../../components/InfoTooltip";
import UserImageCircle from '../../components/UserImageCircle';
import { useAuth } from '../../providers/AuthProvider';

export default class BiddingBriefStep extends ProjectBiddingWizardStep {

    static slug = 'brief';
    static path = '/brief';
    static StepHeader = 'Select individuals from the talent pool';

    // static StepName = 'Project Brief'
    static StepName = 'Brief';
    // static StepName = 'View Project Brief';
    static StepTitle = 'Project Brief';

    static stepHeaderFor(project) {
        if (project.isBYO()) {
            return '';
            // return 'Define project details to share with potential candidates';
            // return 'Build Your Own Team'
        }
        if (project.service) {
            return project.service.name;
        }

        return project.name
    }
    static iconFor(project) {
        return <i className="tab-icon fas fa-tasks"/>
    }
    static accomplishedForProject(project) {
        return true;
    }

    constructor(props, context) {
        super(props, context);

        this.briefRef = React.createRef();
        this.state = {
            ...this.state,
            isLoading: false,
            error: null,
        };
    }

    shouldCaptureRequests() {
        return false;
    }

    async componentDidMount() {
        super.componentDidMount();
    }


    async onRequest(request) {
        if (this.props.project.isBYO()) {
            return;
        }

        if (this.props.isDisabled) return;

        await this.props.toggleUsability(false);

        let response = await request();

        await this.props.toggleUsability(true);

        return response;
    }

    toggleUsability(toggle) {
        this.props.toggleUsability(toggle);
    }

    toggleDisabled(disabled) {
        this.toggleUsability(!disabled);
    }

    render() {
        return (
            <div className="flex-grow container-fluid flex flex-col items-stretch">
                <div className="px-2 flex flex-col bidding-brief-step">

                    {this.renderStepHeader()}

                    <BiddingBrief
                        toggleDisabled={this.toggleDisabled.bind(this)}
                        isDisabled={this.props.isDisabled || this.state.isDisabled || this.props.project.hasRequestedSOW()}
                    />
                </div>
            </div>
        );
    }
}

const BriefWizardStep = (props) => {
    const {project, isLoading, isProjectUpdating, update, isDisabled: isProjectDisabled, requestSOW, postUpdate} = useProject();

    const params = useParams();
    const {section} = params;
    const navigate = useNavigate();
    const location = useLocation();
    const { auth } = useAuth();

    const {
        toggleUsability,
        queryParams,
        isDisabled: isWizardDisabled,
        goToStep
    } = useOutletContext();

    if(!project) return null;

    if (!section) {
        return <Navigate to={{...location, pathname: './details'}} replace={true}/>
    }

    const totalPositions = project.positions?.length;
    const filledPositions = project.positions.filter(posi => posi.hasBeenFilled())
    const canAuthRequestSOW = auth.canRequestSOWForProject(project)
    const isDisabled = isProjectDisabled || isProjectUpdating || props.isDisabled;

    const renderCTA = () => {
        if (project.isPendingContract()) {
            return (
                <button
                    type="button"
                    id="request-sow-btn"
                    onClick={() => {
                        if (!canAuthRequestSOW) {
                            return TB.showPermissionError();
                        }
                        return navigate('../../contract');
                    }}
                    className={TB.mapClass("btn btn-primary btn-block w-full", {
                        'disabled-edit-link': !project.hasFilledAllPositions(),
                    })}
                >
                    View SOW
                    {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                        <i className="fa fa-lock ml-1" />
                    )}
                </button>
            )
        }
        if (project.hasRequestedSOW()) {
            return (
                <p className="text-bold">SOW Requested</p>
            )
        }

        return (
            <>
                <button
                    type="button"
                    id="request-sow-btn"
                    onClick={() => {
                        if (!canAuthRequestSOW) {
                            return TB.showPermissionError();
                        }
                        return requestSOW();
                    }}
                    className={TB.mapClass("btn btn-primary btn-block w-full", {
                        'disabled-edit-link': !project.hasFilledAllPositions() || !!project.contract_requested_at,
                    })}
                    // disabled={!project.hasFilledAllPositions() || isDisabled}
                >
                    Request SOW
                    {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                        <i className="fa fa-lock ml-1" />
                    )}
                </button>

                {!project.hasFilledAllPositions() && (
                    <InfoTooltip type="gray" placement="bottom" target="request-sow-btn">
                        <p className="p-0 text-white">All positions must be filled to request SoW</p>
                    </InfoTooltip>
                )}
            </>
        )
    }

    return (
        <React.Fragment>
            <BiddingBriefStep
                project={project}
                location={location}
                params={{section}}
                navigate={navigate}
                updateProject={postUpdate}
                toggleUsability={toggleUsability}
                queryParams={queryParams}
                isDisabled={isWizardDisabled || isProjectUpdating}
                goToStep={goToStep}
            />
            <Affix offsetBottom={-1} style={{zIndex: 25}}>
                <div className="bidding-footer-nav bidding-footer-alt drop-shadow-xl">
                    <div className="w-full flex justify-end max-w-[1225px]">


                        <div className="flex items-center gap-x-8 md:gap-x-16">



                            <div>
                                {project.hasRequestedSOW() ? (
                                    <p className="text-bold">
                                        <i className="fas fa-check mr-1 text-success"/>
                                        {`SoW ${project.isAwaitingContract() ? 'requested' : 'ready'} for ${project.isService() ? 'Team' : `${filledPositions.length} positions`}`}
                                    </p>
                                ):(
                                    <p className="text-bold">{!project.isService() ? `${filledPositions.length} of ${totalPositions} positions filled` : `${project.shortlisted_candidates_count} proposals requested.`}</p>
                                )}
                            </div>

                            <div className="hidden md:flex flex-row items-center gap-2">
                                {project.positions && project.positions.map((position, index) => {

                                    let hasBeenFilled = position.hasBeenFilled();
                                    let talent = {};

                                    if (hasBeenFilled && position.assigned_candidate) {
                                        talent = position.assignedCandidate()
                                    }

                                    let assigned = (hasBeenFilled && talent?.image_path);
                                    // let active = parseInt(positionId) === position.id;
                                    let key = `pos${position.id}-talent${talent?.id || 'unassigned'}`;

                                    let targetPath = position.currentBriefStep();
                                    let canNavigate = !location.pathname.includes(targetPath);

                                    return (
                                        <div key={key}
                                            className={TB.mapClass("position-swiper-slide", {
                                                assigned,
                                                unassigned: !assigned,
                                                //  active
                                            })}
                                        >
                                            <div
                                                id={key}
                                                className={TB.mapClass("role-img", {
                                                    clickable: canNavigate
                                                })}
                                                onClick={(e) =>{
                                                    if (canNavigate) {
                                                        navigate({
                                                            pathname: `/client/project/bidding/${project?.id}${targetPath}`,
                                                            search: '?from=brief'
                                                        })
                                                    }

                                                }}
                                            >
                                                {(hasBeenFilled && talent?.image_path) ? (
                                                    <UserImageCircle
                                                        user={talent}
                                                        hideTooltip={true}
                                                        size={50} className="img-fluid img-grayscale"/>
                                                ) : (
                                                    <span>
                                                        <i className="fa fa-user-circle"/>
                                                        <span className="position-index">
                                                            {index + 1}
                                                        </span>
                                                    </span>
                                                )}
                                            </div>

                                            <InfoTooltip type="dark" placement="bottom" target={key}>
                                                <div className="position-tooltip">
                                                    <p>{position.title}</p>
                                                    <p>
                                                        {hasBeenFilled ? talent.firstNamePlusInitial?.() : "TBD"}
                                                    </p>
                                                </div>
                                            </InfoTooltip>
                                        </div>
                                    )
                                })}
                            </div>

                            <div>
                                {renderCTA()}
                            </div>

                        </div>
                    </div>
                </div>
            </Affix>
        </React.Fragment>
    )
}

export {
    BriefWizardStep
}